import {
  StatsHypothesisResultFragment,
  StatsV2AnalysisStatsAnnotationContext,
} from '@spotify/confidence-graphql';

import { AnnotationV2 } from '../types';

export const getMetricAnnotations = (
  results?: StatsHypothesisResultFragment[],
): Record<string, AnnotationV2[]> => {
  if (!results) {
    return {};
  }

  const annotationMap: Record<string, AnnotationV2[]> = {};
  ((results ?? []).flatMap(result => result?.annotations) ?? []).forEach(
    annotation => {
      const context = (annotation?.context ?? []).find(
        item =>
          item.key ===
          StatsV2AnalysisStatsAnnotationContext.StatsAnnotationContextHypothesis,
      );
      if (context === undefined) {
        return;
      }

      if (context.value) {
        if (!Object.hasOwn(annotationMap, context.value)) {
          annotationMap[context.value] = [];
        }
        annotationMap[context.value].push({
          info: annotation.info ?? undefined,
          warning: annotation.warning ?? undefined,
          error: annotation.error ?? undefined,
          context: annotation.context ?? undefined,
        });
      }
    },
  );
  return annotationMap;
};
